/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_60e6c3ea"]'><cube-button outline active>outline</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_60e6c3ea"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_60e6c3ea"}
  /** script content **/
  require("./btn-outline-active.mpx.js?isComponent&outputPath=components%2Fbtn-outline-active60e6c3ea%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-outline-active.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-outline-active60e6c3ea%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_60e6c3ea"],
    ctorType: "component",
    outputPath: "components/btn-outline-active60e6c3ea/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>